import React from 'react';

import { 
    Modal,
    Row,
    Col,
    Button,
    Form,
} from "react-bootstrap-v5";

// import Utils from '../../../../utils/utils';

import { StyledCheck, StyledChecked, StyledUnChecked, StyledFormText } from '../style/styles';

import { useDispatch, useSelector } from "react-redux";
import {RootState} from '../../../../../setup'
import payrollBetaCopyJobTypes from '../redux/payrollBetaCopyJobTypes';



const CopyJobType = (props: any) => {
    const dispatch = useDispatch();
    const { show, geofenceIndex, jobTemplateId, jobTypes, checkedJobTypes } = useSelector((state: RootState) => state.payrollBetaCopyJobTypes);
    

    const hide = () => {
        dispatch(payrollBetaCopyJobTypes.hide());
    }
    const onSave = () => {
        dispatch(payrollBetaCopyJobTypes.hide());

        if(props.onSave){
            props.onSave(jobTemplateId, checkedJobTypes, geofenceIndex);
        }
    }


    return <Modal
        show={show}
        onHide={hide}
        backdrop={"static"}
        // fullscreen={true}
        scrollable={true}
        keyboard={false}
        enforceFocus={false}
    >
        <Modal.Header closeButton={true}>Where do you wish to copy to?</Modal.Header>

        <Modal.Body style={{ maxHeight: '217px' }}>
            {
                (jobTypes && jobTypes.length > 0)
                ?
                <Row>
                    {jobTypes.filter(x => x.jobTemplateId !== jobTemplateId).map((item: any, i: number) => {
                        return <Col xs={12} className={'mb-2'} key={'jobTypes_' + i + '_' + item.jobTemplateId + '_key'}>
                            <StyledCheck id={'jobTypes_' + i + '_' + item.jobTemplateId + '_cb'}>
                                <Form.Check.Input
                                    type={'checkbox'}
                                    className={'d-none'}
                                    defaultChecked={checkedJobTypes.find((x: any) => x === item.jobTemplateId) ? true : false}
                                    onClick={(e: any) => {
                                        dispatch(payrollBetaCopyJobTypes.setCheckedJobTypes(item.jobTemplateId));
                                    }}
                                />
                                <Form.Check.Label>
                                    <Row className={'align-items-center g-2'}>
                                        <Col xs={'auto'}>{checkedJobTypes.find((x: any) => x === item.jobTemplateId) ? <StyledChecked className={'fas fa-check'} /> : <StyledUnChecked className={'fas fa-check'} />}</Col>
                                        <Col xs={'auto'}><StyledFormText>{item.jobTemplateName}</StyledFormText></Col>
                                    </Row>
                                </Form.Check.Label>
                            </StyledCheck>
                        </Col>
                    })}
                </Row>
                :
                <>No job types</>
            }
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'flex-start' }}>
            <Row className={'m-0 align-items-center'}>
                <Col xs={'auto'}>
                    <Button 
                        type={'button'}
                        variant={'primary'}
                        size={'sm'}
                        onClick={onSave}
                    >
                        Save
                    </Button>
                </Col>
                <Col xs={'auto'}>
                    <Button 
                        type={'button'}
                        variant={'secondary'}
                        size={'sm'}
                        onClick={hide}
                    >
                        Cancel
                    </Button>
                </Col>
            </Row>
        </Modal.Footer>
    </Modal>
}


export default CopyJobType;
